import { useForm } from 'react-hook-form';
import { COEFFICIENT } from 'constants/formFields';

import type { TMAInsightsDashboardSchema } from 'utils/validators/MASurveyValidators';

const useSettingWeightingForm = () => {
  const {
    control,
    reset,
    watch,
    setValue,
    formState: { isDirty },
  } = useForm<TMAInsightsDashboardSchema>({
    mode: 'onChange',
    defaultValues: {
      [COEFFICIENT]: [],
    },
  });

  return {
    control,
    reset,
    watch,
    setValue,
    isDirty,
  };
};

export default useSettingWeightingForm;
